import { v4 } from 'uuid'
import { UserAttributeDefKeys, UserAttributeDefs } from '../../..'
import { DEBUG_OVERRIDE, NOT_LAMBDA } from '../../../util/lambda'
import { ModelCommon } from '../../ModelCommon'
import { EntityProgrammeSetConstructorProps, supportedTypes } from './types'

const debug = DEBUG_OVERRIDE || (NOT_LAMBDA && false)

export class EntityProgrammeSet extends ModelCommon {
  constructor({ id = v4(), supportedType, maxProgrammes, name, appliedTimestampsMs, enabled, ...others }: EntityProgrammeSetConstructorProps) {
    super('EntityProgrammeSet', { id, ...others })
    this.maxProgrammes = maxProgrammes ?? 5
    this.name = name
    this.supportedType = supportedType
    this.appliedTimestampsMs = appliedTimestampsMs ?? null
    this.enabled = enabled ?? true
  }
  supportedType: string
  maxProgrammes: number | null
  name: string
  appliedTimestampsMs: null | number[]
  enabled: boolean
  maxAppliedTimestamps: number = 50

  getUserAttributes(): UserAttributeDefs & { maxProgrammes: UserAttributeDefKeys } {
    return {
      ...super.getUserAttributes(),
      supportedType: {
        type: 'Enum',
        editable: true,
        required: true,
        enumKv: supportedTypes,
      },
      maxProgrammes: {
        type: 'Number',
        default: 5,
        editable: false,
        label: `Max Programmes`,
        precision: 0,
        required: true,
        description: 'the maximum number of programmes allowed with a set. For default IoTV Devices this is set to 5',
      },
    }
  }

  updateAppliedTimestamps = (timestampMs: number) => {
    if (!this.appliedTimestampsMs) {
      this.appliedTimestampsMs = []
    }
    this.appliedTimestampsMs?.unshift(timestampMs)
    this.appliedTimestampsMs = this.appliedTimestampsMs.slice(0, this.maxAppliedTimestamps)
  }
}
